import axios from 'axios';
import ConfigConnection from '../config/api.service';

export default class LoginService{
  
  token = "fbTjxq4b9KTrUNmW7Usd"
  // API Instance
  configConnection = new ConfigConnection();
  login(user){
    const _ = this;
    // let config = {
    //   headers: {
    //     Authorization: `Bearer ${sessionStorage.getItem('accountTk')}`
    //   }
    // };
    return axios.post(`${_.configConnection.apiInstance}login`, user);
  }

  registryNewAccount(conditions){
    let config = {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    };
    return axios.post(`${this.configConnection.apiInstance}account`, conditions, config);
  }

  registryNewCommerce(conditions){
    let config = {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    };
    return axios.post(`${this.configConnection.apiInstance}merchant`, conditions, config);
  }

  contact(conditions){
    let config = {
      headers: {
        Authorization: `Bearer ${this.token}`
      }
    };
    return axios.post(`${this.configConnection.apiInstance}contact`, conditions, config);
  }

  confirmAccount(conditions){
    return axios.post(`${this.configConnection.apiInstance}info`, conditions)
  }
}
